"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayState = exports.PlayMode = void 0;
var PlayState;
exports.PlayState = PlayState;

(function (PlayState) {
  PlayState["prepare"] = "prepare";
  PlayState["ready"] = "ready";
  PlayState["start"] = "start";
  PlayState["pause"] = "pause";
  PlayState["continue"] = "continue";
  PlayState["stop"] = "stop";
  PlayState["destroyed"] = "destroyed";
})(PlayState || (exports.PlayState = PlayState = {}));

var PlayMode;
exports.PlayMode = PlayMode;

(function (PlayMode) {
  PlayMode["ori"] = "ori";
  PlayMode["acc"] = "acc";
  PlayMode["rhythm"] = "rhythm";
  PlayMode["midiNoVolume"] = "midiNoVolume";
  PlayMode["midi"] = "midi";
  PlayMode["rollCall"] = "rollCall";
  PlayMode["singAlong"] = "singAlong";
})(PlayMode || (exports.PlayMode = PlayMode = {}));